// eslint-disable-next-line import/prefer-default-export
export enum ProgressiveQuizMode {
  EDIT,
  ANSWER,
  REVIEW,
}
